import { render, staticRenderFns } from "./ItemRegular.vue?vue&type=template&id=79e7d168"
import script from "./ItemRegular.vue?vue&type=script&lang=js"
export * from "./ItemRegular.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports